import api from './api.service';
import type {
  DraftsResponse,
  WorkboardActivityResponse,
  WorkboardPersonalFollowUp,
  WorkboardResponse,
} from '@/types/enterprise-work-item';

function unwrap<T>(res: unknown): T {
  const data = (res as { data?: { data?: T } | T })?.data ?? res;
  return ((data as { data?: T })?.data ?? data) as T;
}

export async function getWorkboard(opts?: { sync?: boolean }): Promise<WorkboardResponse> {
  const params: Record<string, string> = {};
  if (opts?.sync) params.sync = '1';
  const res = await api.get('/home/workboard', { params });
  return unwrap<WorkboardResponse>(res);
}

export async function getWorkboardActivity(limit = 30): Promise<WorkboardActivityResponse> {
  const res = await api.get('/home/workboard/activity', { params: { limit } });
  return unwrap<WorkboardActivityResponse>(res);
}

export async function getMyDrafts(): Promise<DraftsResponse> {
  const res = await api.get('/home/drafts');
  return unwrap<DraftsResponse>(res);
}

export async function upsertWorkboardFollowup(input: {
  entityType: string;
  entityId: string;
  documentNumber?: string;
  followUpDate: string;
  note?: string;
  title?: string;
  actionRoute?: string;
}): Promise<WorkboardPersonalFollowUp[]> {
  const res = await api.put('/home/workboard/followups', input);
  const data = unwrap<{ items: WorkboardPersonalFollowUp[] }>(res);
  return data.items ?? [];
}

export async function removeWorkboardFollowup(
  entityType: string,
  entityId: string
): Promise<WorkboardPersonalFollowUp[]> {
  const res = await api.delete('/home/workboard/followups', {
    params: { entityType, entityId },
  });
  const data = unwrap<{ items: WorkboardPersonalFollowUp[] }>(res);
  return data.items ?? [];
}
